import { observer } from 'mobx-react'
import React, { useContext, useEffect, useMemo, useState, Fragment } from 'react'
import { StoreContext } from '@store/Root.store'
import { Button, Header, LoadingSpinner } from '@/components/Generic'
import { forceRedirect } from '@/methods/forceRedirect'
import { API_URL, ONBOARDING_SERVICE_PATH } from '@/constants/apiUrl'
import { errorMap, ErrorPageTypeObject } from '@/constants/errorMap'
import { Illustration } from '@/components/Illustration/Illustration'
import { ErrorEnpalPage } from './enpal/ErrorEnpalPage'

export const ErrorPage = observer(() => {
  const store = useContext(StoreContext)
  const { errorPage: trans } = store.TranslationsState.translations
  const { themeId } = store.InterfaceState

  const [error, setError] = useState<ErrorPageTypeObject>()

  const path = window.location.pathname.split('/')[1]

  const [buttonDisabled, setButtonDisabled] = useState(false)

  const redirectToProcess = () => {
    const url = window.location.search
    const queryParams = new URLSearchParams(url)
    const stage = queryParams.get('stage')
    const token = queryParams.get('token')

    if (stage === 'proceed' && token) {
      setButtonDisabled(true)
      forceRedirect(
        `${API_URL}/${ONBOARDING_SERVICE_PATH}/proceed?proceedToken=${token}&ignoreUnsupportedBrowser=true`
      )
    }
  }

  // Init error screen based on
  useEffect(() => {
    const error = errorMap[path]?.type ? errorMap[path] : errorMap.error

    setError(error)
  }, [trans])

  const errorTitle = useMemo(() => {
    return error?.titleKey ? trans[error.titleKey] : trans.title
  }, [error, trans])

  if (themeId === 'enpalTheme' && path === 'error-transaction-cancelled') {
    return <ErrorEnpalPage />
  }

  if (!error) {
    return (
      <div className="page-container mobile-m-0">
        <LoadingSpinner />
      </div>
    )
  }

  return (
    <div className="page-container mobile-m-0 vertically-centered">
      <Illustration type={error.type} />

      <Header className="m-0-0-30">
        {errorTitle?.split('<br />').map((line: string, index: number) => (
          <Fragment key={index}>
            {line}
            {index < errorTitle.split('<br />').length - 1 && <br />}
          </Fragment>
        ))}
      </Header>

      {error.descriptionKey && trans[error.descriptionKey] && (
        <p className="generic__paragraph-centered m-0-0-30">{trans[error.descriptionKey]}</p>
      )}

      {path.includes('browser-not-supported') && (
        <Button
          disabled={buttonDisabled}
          onClick={redirectToProcess}
          className="button--fit-content-center"
        >
          {buttonDisabled ? <LoadingSpinner inButton /> : trans.browserNotSupportedProceed}
        </Button>
      )}
    </div>
  )
})
